import type { PluginExports } from 'graylog-web-plugin/plugin';

import SearchResultsFromJSON from 'data-lake/preview/types/internal/SearchResultsFromJSON';
import { EXTERNAL_DATA_LAKE_STORAGE_TYPE } from 'data-lake/preview/types/aws-security/Constants';
import AwsSecurityDataLakePreview from 'data-lake/preview/types/aws-security/AwsSecurityDataLakePreview';
import AwsSecurityDataLakeIcon from 'data-lake/preview/types/aws-security/AwsSecurityDataLakeIcon';
import { EXTERNAL_DATA_LAKE_QUERY_TYPE, EXTERNAL_DATA_LAKE_SEARCH_TYPE } from 'data-lake/preview/Constants';

const awsSecurityDataLakeExport: PluginExports = {
  searchTypes: [
    {
      type: EXTERNAL_DATA_LAKE_SEARCH_TYPE,
      handler: SearchResultsFromJSON,
      defaults: {},
    },
  ],
  dataLakeStorageTypes: [
    {
      icon: AwsSecurityDataLakeIcon,
      previewComponent: AwsSecurityDataLakePreview,
      searchType: EXTERNAL_DATA_LAKE_SEARCH_TYPE,
      queryType: EXTERNAL_DATA_LAKE_QUERY_TYPE,
      storageType: EXTERNAL_DATA_LAKE_STORAGE_TYPE,
    },
  ],
};

export default awsSecurityDataLakeExport;
